import gsap from 'gsap'
import lottieWeb from 'lottie-web'
import { afterTransition } from './afterTransition'

export class Preloader {
  constructor() {
    this.preloader = document.querySelector('.preloader')

    if (this.preloader) {
      this.setupLottie()
      this.playPreloader()
    }
  }
  setupLottie() {
    this.logo = this.preloader.querySelector('.preloader__logo')
    this.logoAnimation = lottieWeb.loadAnimation({ 
      container: this.logo,
      autoplay: true,
      renderer: 'svg',
      loop: true,
      path: '/lottie/intro-logo.json'
    })
  }
  playPreloader() {
    const logo = this.preloader.querySelector('.preloader__logo')
    const headerItems = document.querySelectorAll(
      '.header__logo, .header__menu .menu-item, .header__menu-button'
    )

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => this.preloader.remove()
    })

    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        tl.play()
      }
    }

    tl.from(logo, {
      duration: 1,
      opacity: 0
    })

    tl.fromTo(this.preloader, {
      clipPath: 'inset(0 0 0% 0)'
    },
    {
      duration: 2,
      clipPath: 'inset(0 0 100% 0)',
      ease: 'expo.inOut'
    })

    tl.fromTo(logo, {
      scale: 1,
      yPercent: -50
    },  
    {
      duration: 2,
      scale: 0,
      yPercent: -50,
      ease: 'expo.inOut'
    }, '<')

    tl.add(() => {
      Alpine.store('hasPreloader').setPreloaderState()
    }, '<')

    tl.fromTo(headerItems, {
      y: 50
    },
    {
      y: 0,
      duration: 1.4,
      stagger: 0.08,
      ease: 'power3.inOut'
    }, '-=1.2')

    tl.add(() => {
      afterTransition()
    }, 1.4)
  }
}

export default () => {}